var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDOrder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "2.75vw",
    height: "2.5vh",
    viewBox: "0 0 1 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1665 3.8335H5.83317C4.9127 3.8335 4.1665 4.57969 4.1665 5.50016V16.3335C4.1665 17.254 4.9127 18.0002 5.83317 18.0002H14.1665C15.087 18.0002 15.8332 17.254 15.8332 16.3335V5.50016C15.8332 4.57969 15.087 3.8335 14.1665 3.8335Z",
    stroke: "#595959"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8H12.5M7.5 11.3333H12.5M7.5 14.6667H10.8333",
    stroke: "#595959",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDOrder);
export default __webpack_public_path__ + "static/media/D_order.1542c9d446716995a197fcbc04ffdc2c.svg";
export { ForwardRef as ReactComponent };